module.exports = __webpack_public_path__ + "img/delete-fail.7ee4dfe5.svg";